// extracted by mini-css-extract-plugin
export var chatHtmlText = "_u3-2";
export var chatLink = "_u3-0";
export var chatText = "_u3-1";